// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Complete Profile Page Styles */

.complete-profile-page {
  min-height: 100vh;
  background-color: #ebebeb;
  padding-top: 40px;
  padding-bottom: 40px;
}

.fileContainer {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* Button Styling */
.complete-profile-page .theme-btn {
  background-color: #000 !important;
  color: white !important;
}

.complete-profile-page .theme-btn:hover {
  background-color: #000 !important;
}

/* Stepper Customization */
.complete-profile-page .MuiStepIcon-root.Mui-active {
  color: #2e5263 !important;
}

.complete-profile-page .MuiStepIcon-root.Mui-completed {
  color: #4CAF50 !important;
}

/* Progress Bar */
.complete-profile-page .MuiLinearProgress-bar {
  background-color: #4CAF50 !important;
}

/* Radio Group Spacing */
.complete-profile-page .MuiFormControl-root {
  width: 100%;
}

/* Responsive Design */
@media (max-width: 600px) {
  .complete-profile-page {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .complete-profile-page .MuiCardContent-root {
    padding: 24px 16px !important;
  }

  .complete-profile-page .MuiStepper-root {
    padding-left: 0;
    padding-right: 0;
  }

  .fileContainer {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (min-width: 601px) and (max-width: 960px) {
  .complete-profile-page {
    padding-top: 30px;
    padding-bottom: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/auth/completeProfile/CompleteProfile.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF","sourcesContent":["/* Complete Profile Page Styles */\n\n.complete-profile-page {\n  min-height: 100vh;\n  background-color: #ebebeb;\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n.fileContainer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n/* Button Styling */\n.complete-profile-page .theme-btn {\n  background-color: #000 !important;\n  color: white !important;\n}\n\n.complete-profile-page .theme-btn:hover {\n  background-color: #000 !important;\n}\n\n/* Stepper Customization */\n.complete-profile-page .MuiStepIcon-root.Mui-active {\n  color: #2e5263 !important;\n}\n\n.complete-profile-page .MuiStepIcon-root.Mui-completed {\n  color: #4CAF50 !important;\n}\n\n/* Progress Bar */\n.complete-profile-page .MuiLinearProgress-bar {\n  background-color: #4CAF50 !important;\n}\n\n/* Radio Group Spacing */\n.complete-profile-page .MuiFormControl-root {\n  width: 100%;\n}\n\n/* Responsive Design */\n@media (max-width: 600px) {\n  .complete-profile-page {\n    padding-top: 20px;\n    padding-bottom: 20px;\n  }\n\n  .complete-profile-page .MuiCardContent-root {\n    padding: 24px 16px !important;\n  }\n\n  .complete-profile-page .MuiStepper-root {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .fileContainer {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n@media (min-width: 601px) and (max-width: 960px) {\n  .complete-profile-page {\n    padding-top: 30px;\n    padding-bottom: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
